import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home";

export default function App() {
    return (
        <Router>
            <div>
                <Switch>
                    {/* <Route path="/vendedores">
                        <Sellers />
                    </Route> */}
                    <Route path="/:surveyId">
                        <Home />
                    </Route>
                </Switch>
            </div>
        </Router>
    );
}
